<template>
  <div>
    <div
      class="modal fade"
      id="modalAsignarCliente"
      tabindex="-1"
      role="dialog"
      style="backdrop-filter: blur(6px)"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-12">
              <div class="text-center">Información supercliente</div>
              <br />
              <span
                ><span class="font-weight-bold text-success">código: </span
                >{{ current.super_cliente.codigo }}
                <br />
                <span class="font-weight-bold text-success">nombre: </span>
                {{ current.super_cliente.nombre }}</span
              >
            </div>
            <br />
            <ClientesSelectComponent :current="current_" />
            <br />
            <button
              @click="AbrirModalAggNuevoCliente()"
              class="btn btn-md btn-outline-success btn-block"
            >
              Crear nuevo cliente
              <i class="fas fa-user"></i>
            </button>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cerrar
            </button>
            <button
              type="button"
              @click="agregarClienteAsuperCliente()"
              class="btn btn-primary"
            >
              Asignar cliente <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalAsignarRuta"
      tabindex="-1"
      role="dialog"
      style="backdrop-filter: blur(6px)"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-12">
              <div class="text-center">Información supercliente</div>
              <br />
              <span
                ><span class="font-weight-bold text-success">código: </span
                >{{ current.super_cliente.codigo }}
                <br />
                <span class="font-weight-bold text-success">nombre: </span>
                {{ current.super_cliente.nombre }}</span
              >
            </div>
            <br />
            <RutasRepartoSelectComponent :current="current_" />
            <br />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cerrar
            </button>
            <button
              type="button"
              @click="agregarRutasuperCliente()"
              class="btn btn-primary"
            >
              Asignar ruta <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddSuperCliente"
      style="backdrop-filter: blur(6px)"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h6 class="modal-title">Nuevo Super Cliente</h6>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="false">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <label
                  v-bind:class="{
                    'text-danger':
                      current.error_supercliente && current.error_supercliente.nombre,
                  }"
                  >Nombre</label
                >
                <div class="input-group">
                  <input
                    v-model="current.nombre"
                    class="form-control"
                    placeholder="Nombre"
                    v-bind:class="{
                      'is-invalid':
                        current.error_supercliente && current.error_supercliente.nombre,
                    }"
                    type="text"
                  />
                  <small
                    v-if="current.error_supercliente && current.error_supercliente.nombre"
                    class="form-text text-danger"
                    >{{ current.error_supercliente.nombre[0] }}</small
                  >
                </div>
              </div>
              <div class="col-sm-12 col-md-12">
                <label
                  v-bind:class="{
                    'text-danger':
                      current.error_supercliente && current.error_supercliente.direccion,
                  }"
                  >Dirección</label
                >
                <div class="input-group">
                  <textarea
                    v-model="current.direccion"
                    class="form-control"
                    placeholder="Dirección"
                    autofocus="autofocus"
                    rows="1"
                    v-bind:class="{
                      'is-invalid':
                        current.error_supercliente &&
                        current.error_supercliente.direccion,
                    }"
                    type="text"
                  ></textarea>
                  <small
                    v-if="
                      current.error_supercliente && current.error_supercliente.direccion
                    "
                    class="form-text text-danger"
                    >{{ current.error_supercliente.direccion[0] }}</small
                  >
                </div>
              </div>
              <div class="col-12">
                <label for>DPI</label>
                <div class="input-group">
                  <input
                    v-model="current.dpi"
                    class="form-control"
                    placeholder="DPI"
                    type="number"
                  />
                  <small
                    v-if="current.error_supercliente && current.error_supercliente.dpi"
                    class="form-text text-danger"
                    >{{ current.error_supercliente.dpi[0] }}</small
                  >
                </div>
              </div>
              <div class="col-12">
                <label for>Teléfono</label>
                <div class="input-group">
                  <input
                    v-model="current.telefono"
                    class="form-control"
                    placeholder="Teléfono"
                    type="number"
                  />
                  <small
                    v-if="
                      current.error_supercliente && current.error_supercliente.telefono
                    "
                    class="form-text text-danger"
                    >{{ current.error_supercliente.telefono[0] }}</small
                  >
                </div>
              </div>
              <div class="col-12"><TiendaSelectComponent :current="current" /></div>
              <div class="col-12"><ClientesSelectComponent :current="current" /></div>
              <div class="col-12"><RutasRepartoSelectComponent :current="current" /></div>

              <div v-if="!current.cliente_nit" class="col-12">
                <button
                  @click="AbrirModalAggNuevoCliente()"
                  class="btn btn-md btn-outline-success btn-block"
                >
                  Crear nuevo cliente
                  <i class="fas fa-user"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="guardarCliente()">
              Agregar <i class="fas fa-plus"></i>
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModalCliente"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalAgregarnuevoCliente"
      tabindex="-1"
      style="backdrop-filter: blur(6px)"
      role="dialog"
      aria-labelledby="modalAsignarClienteLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <form @submit="guardarClienteNuevo">
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <h6 class="text-success">
                      Nuevo cliente <i class="fas fa-user"></i>
                    </h6>
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.error_cliente && current.error_cliente.nit,
                        }"
                        >NIT</label
                      >
                      <div class="input-group">
                        <input
                          v-model="current_.nit"
                          autofocus="autofocus"
                          class="form-control"
                          placeholder="NIT"
                          type="number"
                          v-bind:class="{
                            'is-invalid':
                              current.error_cliente && current.error_cliente.nit,
                          }"
                        />
                        <small
                          v-if="current.error_cliente && current.error_cliente.nit"
                          class="form-text text-danger"
                        >
                          <span v-if="current.error_cliente.nit == ''"
                            >Nit de cliente no es válido</span
                          >
                          {{ current.error_cliente.nit[0] }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.error_cliente && current.error_cliente.nombre,
                      }"
                      >Nombre</label
                    >
                    <div class="input-group">
                      <input
                        v-model="current_.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{
                          'is-invalid':
                            current.error_cliente && current.error_cliente.nombre,
                        }"
                        type="text"
                      />
                      <small
                        v-if="current.error_cliente && current.error_cliente.nombre"
                        class="form-text text-danger"
                        >{{ current.error_cliente.nombre[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.error_cliente && current.error_cliente.direccion,
                      }"
                      >Dirección</label
                    >
                    <div class="input-group">
                      <textarea
                        v-model="current_.direccion"
                        class="form-control"
                        placeholder="Dirección"
                        autofocus="autofocus"
                        v-bind:class="{
                          'is-invalid':
                            current.error_cliente && current.error_cliente.direccion,
                        }"
                        type="text"
                      ></textarea>
                      <small
                        v-if="current.error_cliente && current.error_cliente.direccion"
                        class="form-text text-danger"
                        >{{ current.error_cliente.direccion[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-12">
                    <label for>Email</label>
                    <div class="input-group">
                      <input
                        v-model="current_.email"
                        class="form-control"
                        placeholder="Email"
                        type="text"
                      />
                      <small
                        v-if="current.error_cliente && current.error_cliente.email"
                        class="form-text text-danger"
                        >{{ current.error_cliente.email[0] }}</small
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-primary" type="submit">Agregar</button>
                <button
                  class="btn btn-secondary"
                  ref="cerrarModalCliente"
                  data-dismiss="modal"
                  type="button"
                >
                  Cerrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <a
      class="btn btn-sm btn-success"
      data-target="#modalAddProductoPrecio"
      data-toggle="modal"
      href="#"
    >
      <span>Nuevo Pedido</span>&nbsp;<i class="fas fa-plus"></i>
    </a>
    <div
      aria-hidden="true"
      class="modal fade"
      style="backdrop-filter: blur(6px)"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Nuevo Pedido</h5>
            <button class="close" type="button" @click="cerrarModalPedido">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        current.errors.tienda && current.errors.tienda.length > 0,
                    }"
                    >Tienda</label
                  >
                  <div class="input-group">
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      required
                      v-model="current.tienda"
                      @input="$emit('input', $event.target.value)"
                      @change="refreshCajas()"
                    >
                      <option
                        v-for="(tienda, key) in tiendas"
                        :value="tienda.codigo"
                        :key="key"
                      >
                        {{ tienda.nombre }}
                      </option>
                    </select>
                  </div>
                  <small
                    v-if="current.errors && current.errors.tienda"
                    class="form-text text-danger"
                  >
                    {{ current.errors.tienda[0] }}
                  </small>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.caja,
                    }"
                    >Cajas</label
                  >
                  <div class="input-group">
                    <select
                      class="form-control"
                      required
                      v-model="current.caja"
                      :disabled="current.tienda == null && cajas == null"
                    >
                      <option v-for="(caja, key) in cajas" :value="caja.id" :key="key">
                        {{ caja.caja }} -
                        <span v-if="caja.esta_abierta == true"> Caja Abierta: Si</span>
                        <span v-if="caja.esta_abierta == false"> Caja Abierta: No</span>
                      </option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.caja"
                      class="form-text text-danger"
                      >{{ current.errors.caja[0] }}</small
                    >
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        current.errors.tipo_pago && current.errors.tipo_pago.length > 0,
                    }"
                    >Tipo de Pago</label
                  >
                  <div class="input-group">
                    <select class="form-control" v-model="current.tipo_pago" required>
                      <option value="CREDITO">Crédito</option>
                      <option :disabled="true" value="CONTADO">Contado</option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.tipo_pago"
                      class="form-text text-danger"
                      >{{ current.errors.tipo_pago[0] }}</small
                    >
                  </div>
                </div>
              </div>
              <div v-if="current.tienda && current.caja" class="col-sm-12 col-md-12">
                <SuperClientesSelectComponent
                  @onChangeCliente="refreshCliente()"
                  :current="current"
                />
              </div>
              <div
                v-if="current.super_cliente.codigo && !current.clientes[0]"
                class="col-sm-12"
              >
                <span class="text-danger"
                  >Este super cliente no tiene ningún cliente asignado</span
                >
                <br />
                <div class="col-12">
                  <br />
                  <button
                    @click="abrirModalCliente()"
                    class="btn btn-md btn-success btn-block"
                  >
                    Asignar cliente a <br />
                    super cliente <i class="fas fa-user"></i>
                  </button>
                </div>
              </div>
              <div v-if="!current.super_cliente.codigo" class="col-12">
                <br />
                <button
                  @click="agregarSuperCliente()"
                  class="btn btn-md btn-outline-success btn-block"
                >
                  Crear nuevo supercliente <i class="fas fa-user"></i>
                </button>
              </div>
              <div v-if="current.clientes[0]" class="col-sm-12">
                <label
                  v-bind:class="{
                    'text-danger': current.errors && current.errors.cliente_nit,
                  }"
                  >Cliente</label
                >
                <div class="input-group row">
                  <select
                    label="nombre"
                    v-model="current.cliente_nit"
                    class="form-control"
                    :disabled="!current.clientes"
                  >
                    <option
                      v-for="(det, key) in current.clientes"
                      :value="det.nit"
                      :key="key"
                    >
                      {{ det.nit }} - {{ det.nombre }}
                    </option>
                  </select>
                  <small
                    v-if="current.errors && current.errors.cliente_nit"
                    class="form-text text-danger"
                    >{{ current.errors.cliente_nit[0] }}</small
                  >
                </div>
                <br />
                <div class="col-12 text-right">
                  <button @click="abrirModalCliente()" class="btn btn-md btn-success">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="crearPedido">
              Agregar <i class="fas fa-plus"></i>
            </button>
            <button class="btn btn-secondary" @click="cerrarModalPedido" type="button">
              Cerrar <i class="fas fa-door-open"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ClienteService from "@/services/catalogos/ClienteService";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import CajaService from "@/services/cxc/CajaService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";
import PedidosServices from "@/services/pos/PedidosServices";
import { mapGetters } from "vuex";
import SuperClientesSelectComponent from "@/components/commons/SuperClientesSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import RutasRepartoSelectComponent from "@/components/commons/RutasRepartoSelectComponent";

export default {
  components: {
    UnidadMedidaSelectComponent,
    TiendaSelectComponent,
    SuperClientesSelectComponent,
    ClientesSelectComponent,
    RutasRepartoSelectComponent,
  },
  data() {
    return {
      current_: {},
      cajas: null,
      cliente: {
        nit: null,
        email: "",
      },
      current: {
        error_supercliente: [],
        error_cliente: [],
        clientes: [],
        super_cliente: {},
        cliente_nit: "",
        cliente_nombre: "",
        cliente_direccion: "",
        tienda: null,
        caja: null,
        tipo_pago: "CREDITO",
        lista_precio: null,
        estado: "A",
        errors: {
          nombre: [],
        },
      },
    };
  },
  props: ["lista_precio", "producto"],
  watch: {},
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    unidad_medida() {
      this.refrescarPrecioVenta();
      return this.current.unidad_medida;
    },
  },
  mounted() {
    let self = this;
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
  },
  methods: {
    AbrirModalAggNuevoCliente() {
      $("#modalAgregarnuevoCliente").modal("show");
    },
    abrirModalCliente() {
      let self = this;
      Notifications.alert.confirm(
        "Asignar nuevo cliente al super cliente.",
        "¿Esta seguro?",
        "",
        function () {
          $("#modalAsignarCliente").modal("show");
          $("#modalAddProductoPrecio").modal("hide");
        }
      );
    },
    agregarSuperCliente() {
      let self = this;
      $("#modalAddSuperCliente").modal("show");
      $("#modalAddProductoPrecio").modal("hide");
    },
    agregarRutasuperCliente() {
      let self = this;
      if (self.current_.ruta_reparto) {
        self.current_.ruta_reparto = self.current_.ruta_reparto.id;
      }
      DynamicService.postAction(
        "cat",
        "super-cliente",
        self.current.super_cliente.codigo,
        "asignar_ruta",
        self.current_
      )
        .then((res) => {
          self.current.errors = {};
          self.refreshCliente();
          self.current.super_cliente = res.data;
          Notifications.toast.success(
            "Realizado exitosamente",
            "¿Desea continuar el pedido?"
          );
          $("#modalAsignarRuta").modal("hide");
          $("#modalAddProductoPrecio").modal("show");
        })
        .catch((error) => {
          self.current.errors = Object.assign({}, error.response.data);
          if ("nit" in error.response.data) {
            Notifications.alert.error(
              "Asignar nuevo cliente a super cliente",
              error.response.data.nit[0]
            );
          }
        });
    },
    agregarClienteAsuperCliente() {
      let self = this;
      if (self.current_.cliente_nit) {
        self.current_.cliente_id = self.current_.cliente_nit.nit;
      }
      DynamicService.postAction(
        "cat",
        "super-cliente",
        self.current.super_cliente.codigo,
        "asignar_cliente",
        self.current_
      )
        .then((res) => {
          self.current.errors = {};
          self.refreshCliente();
          Notifications.toast.success(
            "Realizado exitosamente",
            "¿Desea continuar el pedido?"
          );
          $("#modalAsignarCliente").modal("hide");
          $("#modalAddProductoPrecio").modal("show");
        })
        .catch((error) => {
          self.current.errors = Object.assign({}, error.response.data);
          if ("nit" in error.response.data) {
            Notifications.alert.error(
              "Asignar nuevo cliente a super cliente",
              error.response.data.nit[0]
            );
          }
        });
    },
    refreshCliente() {
      let self = this;
      DynamicService.getById(
        "cat",
        "super-cliente",
        self.current.super_cliente.codigo
      ).then((response) => {
        self.current.clientes = response.data.clientes;
      });
    },
    cerrarModalPedido() {
      $("#modalAddProductoPrecio").find("input,textarea,select").val("");
      $("#modalAddProductoPrecio").modal("hide");
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    refreshCajas() {
      let self = this;
      this.current.caja = "";
      CajaService.fetch({
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.cajas = res.data;
      });
    },
    crearPedido(e) {
      let self = this;
      if (self.current.super_cliente.ruta_reparto.length == 0) {
        Notifications.alert.confirm(
          "Super cliente no tiene ruta asignada",
          "¿Desea agregar la ruta?",
          "Si",
          function () {
            $("#modalAsignarRuta").modal("show");
            $("#modalAddProductoPrecio").modal("hide");
            return;
          }
        );
      } else {
        if (self.current.super_cliente) {
          self.current.cliente_nombre = self.current.super_cliente.nombre;
          self.current.cliente_direccion = self.current.super_cliente.direccion;
          self.current.super_cliente = self.current.super_cliente.codigo;
        }
        if (!self.current.super_cliente) {
          Notifications.alert.confirm(
            "Super cliente no válido",
            "¿Desea agregar nuevo super cliente?",
            "Si",
            function () {
              $("#modalAddProductoPrecio").modal("hide");
              $("#modalAddSuperCliente").modal();
            }
          );
        }
        var _current = Object.assign({}, this.current);
        PedidosServices.save(_current)
          .then((res) => {
            self.current.errors = {};
            Notifications.alert.success("Pedido", "Se ha agregado nuevo pedido");
            self.$router.push({
              name: "pos-pedidos-mayoreo-ver",
              params: { id: res.data.id },
            });
            $("#modalAddProductoPrecio").modal("hide");
            $("#modalAddSuperCliente").modal("hide");
          })
          .catch((error) => {
            console.log(error.response.data);
            self.current.errors = Object.assign({}, error.response.data);
            Vue.nextTick(function () {
              self.current.errors = Object.assign({}, error.response.data);
              if ("detail" in error.response.data) {
                Notifications.alert.error("Error", error.response.data.detail);
              }
            });
          });
      }
    },
    guardarClienteNuevo(e) {
      e.preventDefault();
      let self = this;
      var current = Object.assign({}, self.current_);
      delete current.image;
      if (this.$route.params.nit) {
        current.pk = this.$route.params.nit;
        delete current.nit;
      }
      if (current.lista_precio) {
        current.lista_precio = current.lista_precio.id;
      }
      ClienteService.save(current)
        .then((res) => {
          self.current.cliente_nit = res.data;
          self.current.errors = {};
          Notifications.alert.confirm(
            "Super cliente Agregado exitosamente",
            "¿Desea continuar el pedido?",
            "Si",
            function () {
              $("#modalAgregarnuevoCliente").modal("hide");
            }
          );
        })
        .catch((error) => {
          self.current.error_cliente = Object.assign({}, error.response.data);
          if ("nit" in error.response.data) {
            Notifications.alert.error("Error", error.response.data.nit[0]);
          }
        });
    },
    guardarCliente() {
      let self = this;
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.nit) {
        current.pk = this.$route.params.nit;
        delete current.nit;
      }
      current.nit = current.cliente_nit.nit;
      current.tienda = current.tienda;
      DynamicService.save("cat", "super-cliente", current)
        .then((res) => {
          self.current_.cliente_nit = res.data;
          self.current.errors = {};
          self.current.super_cliente = res.data;
          self.agregarClienteAsuperCliente();
          $("#modalAddSuperCliente").modal("hide");
        })
        .catch((error) => {
          self.current.error_supercliente = Object.assign({}, error.response.data);
          if ("nit" in error.response.data) {
            Notifications.alert.error("Error", error.response.data.nit[0]);
          }
        });
    },
  },
};
</script>
